
import { Component, Vue } from 'vue-property-decorator'

/**
 * ラベルの基底コンポーネント
 */
@Component
export default class LabelBase extends Vue {}
